import { render } from "./CardComponent.vue?vue&type=template&id=54ebc22d&scoped=true"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"

import "./CardComponent.vue?vue&type=style&index=0&id=54ebc22d&scoped=true&lang=css"
import "./CardComponent.vue?vue&type=style&index=1&id=54ebc22d&lang=scss"
import "./CardComponent.vue?vue&type=style&index=2&id=54ebc22d&lang=sass"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ebc22d"]])

export default __exports__